import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0abc801a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popup-content-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请选择地区", -1))

import {ref, computed} from 'vue';
import {Popup, Cascader, CascaderOption} from 'vant';
import CustomEmpty from '@/components/CustomEmpty.vue';
import {usePopReturn} from '@/hooks/usePopReturn';
import {haboClickReport} from '@/plugins/haboConfig';

interface PickerChangeValue {
  value: string | number;
  selectedOptions: CascaderOption[];
  tabIndex: number;
}

// 选择完毕

const __default__ = {
  name: 'AreaPicker',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    show: { type: Boolean },
    toggleShowPicker: null,
    setCurArea: null,
    setAreaIdList: null,
    areaListData: null,
    areaIdList: null,
    areaListRefetch: null
  },
  setup(__props: any) {

const props = __props as {
  show: boolean;
  toggleShowPicker:(show: boolean) => void;
  setCurArea: (cur: string) => void;
  setAreaIdList: (list: number[]) => void;
  areaListData: AreaItem[]; // 所有地区选项数据
  areaIdList: number[];
  areaListRefetch: (params?: {[key: string]: any} | undefined) => Promise<any>;
}



const areaPickerRef = ref<any>();

const showDraft = computed({
  get() {
    return props.show;
  },
  set(val: boolean) {
    props.toggleShowPicker(false);
  },
});

const {handleClose, handleOpen} = usePopReturn(showDraft, () =>
  props.toggleShowPicker(false));

const cascaderValue = ref<number>(0); // 多级选择的最后一级 code
const curSelectOption = ref<CascaderOption[]>([]); // 当前选择的完整链路

const onOpen = () => {
  handleOpen();
  // 每次打开都重置 active 项与外部保持一致
  cascaderValue.value = props.areaIdList[0];
  curSelectOption.value = [{id: props.areaIdList[0]}];
};

const onFinish = () => {
  // 隐藏 picker
  props.toggleShowPicker(false);
  // 埋点
  const province_id = curSelectOption.value[0]?.id?.toString() || '0';
  const city_id = curSelectOption.value[1]?.id?.toString() || '';
  const district_id = curSelectOption.value[2]?.id?.toString() || '';
  haboClickReport('USER_TOGGLE_AREA', {
    province_id,
    city_id: province_id === city_id ? '' : city_id,
    district_id: city_id === district_id ? '' : district_id,
  });

  // 如果没有触发 onChange 说明选择的地区没有改变.
  if (
    !curSelectOption.value.length
    // 比较地区 id 的第一个值和当前选择链的最后一个 id, 如果当前选择的地区没有改变, 就不请求新数据
    || props?.areaIdList?.[0]
      === curSelectOption.value[curSelectOption.value.length - 1]?.id
  ) {
    return;
  }

  // 设置地区名 string, 为选择链路的最后一个 name
  const newCurArea
    = curSelectOption.value[curSelectOption.value.length - 1]?.name ?? '全国';
  // 如果最后一个 name 为全部, 则取倒数第二个 name
  props.setCurArea(
    newCurArea === '全部'
      ? curSelectOption.value[curSelectOption.value.length - 2]?.name
      : newCurArea,
  );

  // 当前选择链路 id 数组, 如 [1, 2, 3]
  let idList = curSelectOption.value.map((item: CascaderOption) => item.id, []);

  // 防止选择链路为空, 默认为 全国, 一般不会出现该情况
  if (idList.length === 0) {
    idList = [0];
  }

  // 设置新的 id 数组, 取选择链路的最后一个 id 即可
  props.setAreaIdList([idList[idList.length - 1]]);
};

// onChange 无法在第一次挂载时就触发
const onChange = ({selectedOptions}: PickerChangeValue) => {
  // 记录选择链路
  curSelectOption.value = selectedOptions;
};

// 重新加载地区数据
const errorBtnClick = () => {
  props?.areaListRefetch();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Popup), {
    show: _unref(showDraft),
    "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => (_isRef(showDraft) ? (showDraft).value = $event : null)),
    round: "",
    position: "bottom",
    class: "area-picker-popup",
    onClose: _unref(handleClose),
    onOpen: onOpen
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(Cascader), {
          ref_key: "areaPickerRef",
          ref: areaPickerRef,
          modelValue: cascaderValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((cascaderValue).value = $event)),
          title: "请选择所在地区",
          options: __props.areaListData || [],
          "field-names": {
          text: 'name',
          value: 'id',
          children: 'subAreaList',
        },
          closeable: false,
          swipeable: "",
          "active-color": "#FF443D",
          onFinish: onFinish,
          onChange: onChange
        }, {
          title: _withCtx(() => [
            _createElementVNode("div", { class: "title-box" }, [
              _hoisted_2,
              _createElementVNode("span", { onClick: onFinish }, "确认")
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "options"]),
        (!__props.areaListData.length)
          ? (_openBlock(), _createBlock(CustomEmpty, {
              key: 0,
              class: "empty",
              type: "error",
              description: "哎呀! 数据加载发生意外",
              "on-click-btn": errorBtnClick
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["show", "onClose"]))
}
}

})